import { BackComponent } from '@/components'
import { TopActionsContainer } from './styles'

interface TopActionsProps {
  onBack?: () => void
  noBack?: boolean
}

export const TopActions = ({ onBack, noBack }: TopActionsProps) => {
  return (
    !noBack && (
      <TopActionsContainer flexDirection={noBack ? 'row-reverse' : 'row'}>
        <BackComponent noContentGutter onBack={onBack} />
      </TopActionsContainer>
    )
  )
}
